import { MigrationStatus } from "../models/MigrationStatus";

/**
 * Deleting an entity deletes the SharePoint folder NFS recorded for it. With no folder recorded, the deletion would
 * remove NFS's records and leave whatever the entity uploaded in SharePoint with nothing pointing at it, so the delete
 * action is withheld once the entity has uploaded anything.
 */
export const deletionWouldStrandUploads = (entity: {
  hasRootFolderInfo: boolean;
  status: MigrationStatus;
  statistics?: { filesMigrated?: number };
}): boolean =>
  !entity.hasRootFolderInfo
  && (entity.status === MigrationStatus.Finished || (entity.statistics?.filesMigrated ?? 0) > 0);

export const STRANDED_UPLOADS_HINT =
  "No SharePoint folder is recorded for it, so deleting it would leave its uploaded files in SharePoint.";
